import { useEffect } from 'react';
import { toast } from '@/hooks/use-toast';
import { AlertTriangle } from 'lucide-react';

/**
 * RateLimitListener - Listens for 429 rate limit events and shows ESPN-style alert
 * This component should be mounted at the app root level
 */
export function RateLimitListener() {
  useEffect(() => {
    const handleRateLimit = (event: CustomEvent) => {
      const cooldownMs =
        typeof (event as any)?.detail?.cooldownMs === 'number'
          ? (event as any).detail.cooldownMs
          : 5000;
      const descriptionText =
        typeof (event as any)?.detail?.message === 'string'
          ? (event as any).detail.message
          : 'SYSTEM COOLING: High traffic detected. Retrying in 5s...';

      toast({
        title: '⚠ SYSTEM COOLING',
        description: (
          <div className="bg-slate-950/90 backdrop-blur-sm p-3 rounded text-white border border-amber-500/20">
            <div className="text-amber-200/90 font-semibold">{descriptionText}</div>
            <div className="text-white/70 text-xs mt-1">
              Queries paused for {Math.round(cooldownMs / 1000)}s.
            </div>
          </div>
        ),
        duration: cooldownMs, // 5s cooling window
      });
    };

    window.addEventListener('rate-limit-throttled', handleRateLimit as EventListener);

    return () => {
      window.removeEventListener('rate-limit-throttled', handleRateLimit as EventListener);
    };
  }, []);

  return null;
}
